import React from 'react';
import Button from '@material-ui/core/Button';
import { makeStyles } from "@material-ui/core/styles";

export const StyledTextButton = React.memo(props => {
  const useStyles = makeStyles(theme => ({
    commonBtnStyle: {
      backgroundColor: theme.agentTheme.primary.main,
      borderRadius: '2px',
      color: theme.agentTheme.primary.foreground,
      fontWeight: 800,
      minWidth: "180px",
      width: "180px",
      height: "48px",
      fontSize: '14px',
      '&:hover': {
        backgroundColor: theme.agentTheme.primary.main,
         color: theme.agentTheme.primary.foreground,
      },
      [theme.breakpoints.down('sm')]: {
        width: '100%',
        marginTop: '32px',
      }
    }
  }))

  const { buttonText = '', buttonRedirect = () => { } } = props
  const classes = useStyles();

  return (<Button className={classes.commonBtnStyle} onClick={buttonRedirect}>
    {buttonText}
  </Button>)
})

export const StyledButton = React.memo(props => {
  const useStyles = makeStyles(theme => ({
    commonBtnStyle: {
      backgroundColor: theme.agentTheme.primary.main,
      color: theme.agentTheme.primary.foreground,
      borderRadius: '2px',
      // width:"307px",
      // height:'56px',
      fontSize: '16px',
      // marginTop: '40px',
      '&:hover': {
        backgroundColor: theme.agentTheme.primary.main,
        color: theme.agentTheme.primary.foreground,
      },
      [theme.breakpoints.down('sm')]: {
        width: '100%',
        marginTop: '32px',
      }
    }
  }))

  const { buttonText = '', buttonRedirect = () => { } } = props
  const classes = useStyles();

  return (<Button className={classes.commonBtnStyle} onClick={buttonRedirect}>
    {buttonText}
  </Button>)
})